import { connect } from 'react-redux';
import { toast } from '../../redux/actions/toasts-actions';
import { 
  loadDealTeam, 
  loadAdminDealMembers,
  loadCommissionTeam,
  addDealMembers,
  addDealTeams,
  addCommissionMembers,
  addCommissionTeams,
  removeDealMembers,
  removeDealTeams,
  removeCommissionMembers,
  removeCommissionTeams,
  loadAdminCommissionMembers,
  addAllAdminCommissionMembers,
  removeAdminCommissionMembers,
  addAllAdminDealMembers,
} from '../../redux/actions/team-members-actions';
import { loadDeal } from '../../redux/actions/deal-actions';
import AdminManageDeal from './admin-manage-deal';

const mapStateToProps = state => ({
  userData: (state.userData.data && state.userData.data.id) ? state.userData.data : {},
  proxy: state.proxy.proxySettings,
  // Add team members Redux state
  dealUsers: state.teamMembers.dealUsers,
  dealTeams: state.teamMembers.dealTeams,
  relatedTransactionUsers: state.teamMembers.relatedTransactionUsers,
  relatedTransactionTeams: state.teamMembers.relatedTransactionTeams,
  adminManageDeal: state.admin.adminManageDeal
});

const AdminManageDealContainer = connect(
  mapStateToProps,
  { 
    toast,
    loadDealTeam,
    loadAdminDealMembers,
    loadAdminCommissionMembers,
    loadCommissionTeam,
    loadDeal,
    addDealMembers,
    addDealTeams,
    addCommissionMembers,
    addCommissionTeams,
    addAllAdminCommissionMembers,
    addAllAdminDealMembers,
    removeDealMembers,
    removeDealTeams,
    removeCommissionMembers,
    removeCommissionTeams,
    removeAdminCommissionMembers,
  },
)(AdminManageDeal);

export default AdminManageDealContainer;
